import React, { useState } from 'react';
import { Card, Table, Typography } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { useCurrency } from '@/contexts/CurrencyContext';
import salesConversionReportsService from '@/services/salesConversionReports.service';
import { defaultSalesReportFilters, SalesReportFilterBar } from './SalesReportFilterBar';

const { Title } = Typography;

const SalesProductMixPage: React.FC = () => {
  const { formatCurrency } = useCurrency();
  const [filters, setFilters] = useState(defaultSalesReportFilters());
  const { data, isLoading } = useQuery({
    queryKey: ['sales-product-mix', filters],
    queryFn: () => salesConversionReportsService.productRstMix(filters),
  });

  const byRst = (data?.by_rst as Array<Record<string, unknown>>) || [];
  const byItem = (data?.by_item as Array<Record<string, unknown>>) || [];

  return (
    <div style={{ padding: 24 }}>
      <Title level={3}>Product / RST mix</Title>
      <SalesReportFilterBar value={filters} onChange={setFilters} showCompare={false} />
      <Card title="By revenue service type" style={{ marginBottom: 16 }}>
        <Table
          loading={isLoading}
          size="small"
          rowKey={(r) => String(r.revenue_service_type)}
          dataSource={byRst}
          columns={[
            { title: 'RST', dataIndex: 'revenue_service_type' },
            { title: 'Invoices', dataIndex: 'invoice_count', align: 'right' },
            {
              title: 'Revenue',
              dataIndex: 'revenue',
              align: 'right',
              render: (v) => formatCurrency(Number(v || 0)),
            },
          ]}
          pagination={false}
        />
      </Card>
      <Card title="Top items (invoice lines)">
        <Table
          loading={isLoading}
          size="small"
          rowKey={(r, i) => `${r.item}-${i}`}
          dataSource={byItem}
          columns={[
            { title: 'Item', dataIndex: 'item', ellipsis: true },
            { title: 'Qty', dataIndex: 'qty', align: 'right' },
            {
              title: 'Revenue',
              dataIndex: 'revenue',
              align: 'right',
              render: (v) => formatCurrency(Number(v || 0)),
            },
          ]}
          pagination={{ pageSize: 25 }}
        />
      </Card>
    </div>
  );
};

export default SalesProductMixPage;
